module.exports = __webpack_public_path__ + "media/images/logo-mobile-207343960832f13c66ce2fca93bd1a41.svg";